import { render } from "./theme40.vue?vue&type=template&id=70db5ab1&scoped=true"
import script from "./theme40.vue?vue&type=script&lang=js"
export * from "./theme40.vue?vue&type=script&lang=js"

import "./theme40.vue?vue&type=style&index=0&id=70db5ab1&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-70db5ab1"

export default script